import { z } from 'zod';
import { PERMISSIONS, terraContract } from '@terra/shared-authorization';
import {
  AssetsParamsSchema,
  AssetsSearchBodySchema,
  AssetsSearchExportReturnSchema,
  AssetsSearchMetricsBodySchema,
  AssetsSearchMetricsReturnSchema,
  AssetsSearchReturnSchema,
} from './assets-search.schema';
import { ErrorResponseSchema } from './assets.schema';

export const ASSETS_SEARCH_PATH_NAME = 'assets-search';

export const AssetsSearchContract = terraContract
  .prefix(`/${ASSETS_SEARCH_PATH_NAME}`)
  .router({
    searchAssets: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/{applicationId}/items',
        summary:
          'Search application assets with server-side filtering and pagination',
        inputStructure: 'detailed',
      })
      .input(
        z.object({ params: AssetsParamsSchema, body: AssetsSearchBodySchema }),
      )
      .output(AssetsSearchReturnSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        NOT_FOUND: { status: 404, data: ErrorResponseSchema },
        INTERNAL_SERVER_ERROR: { status: 500, data: ErrorResponseSchema },
      }),
    getAssetsMetrics: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/{applicationId}/metrics',
        summary: 'Get type-scoped asset metrics and filter facets',
        inputStructure: 'detailed',
      })
      .input(
        z.object({
          params: AssetsParamsSchema,
          body: AssetsSearchMetricsBodySchema,
        }),
      )
      .output(AssetsSearchMetricsReturnSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        NOT_FOUND: { status: 404, data: ErrorResponseSchema },
        INTERNAL_SERVER_ERROR: { status: 500, data: ErrorResponseSchema },
      }),
    exportAssets: terraContract
      .meta({
        permissions: [PERMISSIONS.VIEW_APPLICATIONS.name],
      })
      .route({
        method: 'POST',
        path: '/{applicationId}/export',
        summary: 'Export all assets matching the active filters',
        inputStructure: 'detailed',
      })
      .input(
        z.object({ params: AssetsParamsSchema, body: AssetsSearchBodySchema }),
      )
      .output(AssetsSearchExportReturnSchema)
      .errors({
        BAD_REQUEST: { status: 400, data: ErrorResponseSchema },
        NOT_FOUND: { status: 404, data: ErrorResponseSchema },
        INTERNAL_SERVER_ERROR: { status: 500, data: ErrorResponseSchema },
      }),
  });
